import { useSignal } from "@preact/signals";
import { toast } from "sonner";
import { account, resendVerification } from "~/web/src/auth";
import { Topbar } from "~/web/src/topbar";

// What /billing and /api-keys show an unverified account instead of the page
// (spec: own-auth-spec.md, decision 6, amended 2026-10-30): money and keys
// wait for the mailed link. The server refuses the writes behind them too;
// this is the state that says so, with the banner's Resend.

export function VerifyFirst({ name }: { name: "Billing" | "API keys" }) {
  const a = account.value;
  const busy = useSignal(false);
  async function resend() {
    busy.value = true;
    try {
      const refused = await resendVerification();
      if (refused) toast.error(refused);
      else toast.success(`Sent — check ${a?.email}.`);
    } finally {
      busy.value = false;
    }
  }
  return (
    <div class="app">
      <Topbar name={name} />
      <main class="home">
        <section class="verify-first">
          <h1>Verify your email first</h1>
          <p>
            We mailed a link to <b>{a?.email}</b>. Open it to unlock {name.toLowerCase()} for your
            account — it also signs you in on any device.
          </p>
          <button type="button" class="btn sm" disabled={busy.value} onClick={() => void resend()}>
            Resend the email
          </button>
        </section>
      </main>
    </div>
  );
}
